<template>
 <div>
   <h-section-header back="/dashboard">{{client.first_name}}'s courses</h-section-header>
   <div class="card card--transparent courses" v-for="clientCourse in clientCourses" :key="clientCourse.id">
     <h3>
       {{clientCourse.title}} 
       <h-icon v-if="clientCourse.percent_complete >= 100">check_circle</h-icon>
     </h3>
     <div>
      <course-module 
        :course-module="m" 
        v-for="m in clientCourse.modules"
        :key="m.id" />
     </div>
   </div>

 </div> 
</template>

<script>
import store from "@/services/api/store";
import courseModule from "./courseModule";

export default {
  props: ["client"],
  components: { courseModule },
  data() {
    return {
      clientCourses: []
    };
  },
  created() {
    store.detailRoute(`coaches/client-courses/current/?client=${this.$route.params.id}`)
      .then(clientCourses => {
        this.clientCourses = clientCourses;
      });
  }
};
</script>

<style lang="less" >
.courses {
  margin-top: 15px;
  h3 {
    align-items: center;
    display: flex;
    i {
      margin-left: 10px;
    }
  }
  .name {
    align-items: center;
    display: flex;
    i {
      margin: 0px 10px;
    }
  }
  i {
    font-size: 18px;
  }
}
</style>
